import { Endpoint, Http } from "Application";
import { AppUrls } from "AppUrls";

export class POSTRotaRequest {
    public startDate?: string;
    public copyFromPreviousWeek?: boolean;
    public selectedWeekStartDate?: string;
}

export class POSTRotaResponse {
    public mentorAvailability: any[] = [];
    public rota: any = null;
}

export class POSTRotaEndPoint extends Endpoint<POSTRotaRequest, POSTRotaResponse> {
    constructor() {
        super();
        this.verb(Http.Post);
        this.path(AppUrls.Server.WeeklyRota.SaveRota);
    }

    public async HandleRequestAsync(request: POSTRotaRequest): Promise<POSTRotaRequest> {
        return request;
    }

    public async HandleResponseAsync(response: POSTRotaResponse): Promise<POSTRotaResponse> {
        return response;
    }
}
